import ReactGA from 'react-ga4';
import { getUser } from './auth';

// GA4 Measurement ID. This identifier is public — it appears in the page
// HTML for any visitor — so it's safe to commit. Override at build time with
// REACT_APP_GA_MEASUREMENT_ID if you want a different property (e.g. staging).
const GA_MEASUREMENT_ID =
  process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-Y37Q7D62QX';

// Email whose traffic should never be tracked (used for live sales demos).
const DEMO_EMAIL = 'demo@sunshinebackflow.com';

// Routes we deliberately skip so the dashboard isn't polluted by login churn.
const SKIPPED_PATHS = new Set(['/login']);

let initialized = false;

const shouldTrack = (path) => {
  if (process.env.NODE_ENV !== 'production') return false;
  if (!GA_MEASUREMENT_ID) return false;
  if (path && SKIPPED_PATHS.has(path)) return false;
  const user = getUser();
  if (user?.email === DEMO_EMAIL) return false;
  return true;
};

const ensureInitialized = () => {
  if (initialized) return;
  ReactGA.initialize(GA_MEASUREMENT_ID);
  // Attach the tenant's company name as a custom dimension so traffic can be
  // segmented per customer. To see it in reports, register `company_name` in
  // GA Admin → Custom definitions → Custom dimensions (user-scoped).
  const user = getUser();
  if (user?.company_name) {
    ReactGA.set({ company_name: user.company_name });
  }
  initialized = true;
};

export const trackPageView = (path, title) => {
  if (!shouldTrack(path)) return;
  ensureInitialized();
  ReactGA.send({
    hitType: 'pageview',
    page: path,
    title: title || document.title,
  });
};

export const trackEvent = (name, params = {}) => {
  if (!shouldTrack()) return;
  ensureInitialized();
  ReactGA.event(name, params);
};
